import { render, staticRenderFns } from "./FinalSubmitCheckedComponent.vue?vue&type=template&id=310a1a24&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./FinalSubmitCheckedComponent.vue?vue&type=script&lang=js&"
export * from "./FinalSubmitCheckedComponent.vue?vue&type=script&lang=js&"
import style0 from "./FinalSubmitCheckedComponent.vue?vue&type=style&index=0&id=310a1a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310a1a24",
  null
  
)

component.options.__file = "FinalSubmitCheckedComponent.vue"
export default component.exports